import * as actions from './savePoint.actions'
import { initialState as savePointInitialState, actionsMap as savePointActionsMap } from '../../Mars/SavePoint'

const initialState = {
  ...savePointInitialState,
  currentSceneId: null,
  elementsStatuses: {},
  lastSceneId: null,
  showConsumeWarning: true,
  saving: {
    error: null,
    inProgress: false,
    saved: true,
  },
}

const actionsMap = {
  ...savePointActionsMap,

  // Init saving procedure. Start server communication.
  [actions.SAVE_START]: (state) => {
    return {
      ...state,
      saving: {
        ...state.saving,
        inProgress: true,
      },
    }
  },

  // The saving procedure was successfull
  [actions.SAVE_FINISH_OK]: (state) => {
    return {
      ...state,
      saving: {
        error: null,
        inProgress: false,
        saved: true,
      },
    }
  },

  // The saving procedure was wrong
  [actions.SAVE_FINISH_ERROR]: (state, action) => {
    const error = action.data
    return {
      ...state,
      saving: {
        error,
        inProgress: false,
        saved: false,
      },
    }
  },

  // Synchronization with game
  [actions.GAME_SYNC_SAVEPOINT]: (state, action) => {
    const game = action.data
    const transitionState = {
      currentSceneId: game.currentSceneId,
      lastSceneId: game.lastSceneId,
      showConsumeWarning: game.showConsumeWarning,
    }

    return {
      ...state,
      ...transitionState,
    }
  },

  // Synchronization with user info from login
  [actions.USERINFO_SYNC_SAVEPOINT]: (state, action) => {
    const userInfo = action.data
    const { savePoint } = userInfo
    return {
      ...state,
      ...savePoint,
    }
  },

  // Update object status
  [actions.UPDATE_OBJECT_STATUS]: (state, action) => {
    const { id, status } = action.data

    return {
      ...state,
      elementsStatuses: {
        ...state.elementsStatuses,
        [id]: status,
      },
    }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
